export const getIsErrorModalOpen = state => state.error !== null;
